// API Keys
export const ALREADY_INVALID_API_KEY = 'The API Key is already invalidated.';
